import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import authReducer from './models/Auth/reducer';
import loaderReducer from "./models/Loader/reducer"
// import profileReducer from './models/Profile/reducer';




// Combine reducers
const rootReducer = combineReducers({
    auth: authReducer,
    loader: loaderReducer,
    // profile: profileReducer,
    
});

// Create the store with thunk middleware and Redux DevTools extension
const store = createStore(
    rootReducer,
    composeWithDevTools(applyMiddleware(thunk))
);

export default store;
